<template>
  <header class="sticky top-0 z-50 flex font-interregular items-center justify-between p-7 bg-[#FFF2E0]">
    <!-- Logo Section -->
    <router-link to="/" class="flex items-center">
      <img alt="CWW logo" src="../assets/Frame 24 (1).png" class="w-10 h-10 md:ml-5">
      <img alt="Text logo" src="../assets/LogoText.png" class="ml-2 w-28 h-auto">
    </router-link>

    <!-- Desktop Navigation -->
    <nav class="hidden lg:flex items-center justify-center space-x-6 lg:space-x-6 md:space-x-4 flex-grow">
      <router-link to="/shop">
        <button class="relative text-[#141523] font-archivoregular hover:text-[#FF6000] group px-2 py-2" @click="closeMenu">
          Products
        </button>
      </router-link>
      <router-link to="/wallet">
        <button class="relative text-[#141523] font-archivoregular hover:text-[#FF6000] group px-2 py-2" @click="closeMenu">
          Wallet
        </button>
      </router-link>
      <router-link to="/learn">
        <button class="text-[#141523] font-archivoregular hover:text-[#FF6000] px-2 py-2" @click="closeMenu">Resources</button>
      </router-link>
      <router-link to="/enterprise">
        <button class="relative text-[#141523] font-archivoregular hover:text-[#FF6000] group px-2 py-2" @click="closeMenu">
          Enterprise
        </button>
      </router-link>
      <router-link to="/blog">
        <button class="relative text-[#141523] font-archivoregular hover:text-[#FF6000] group px-2 py-2" @click="closeMenu">
          Blog
        </button>
      </router-link>
      <router-link to="/genesisgiveaway">
        <button class="genesis-btn relative text-white font-archivoregular bg-gradient-to-r from-[#FF6000] to-[#FF8C00] rounded-full shadow-xl border-2 border-transparent px-4 py-2 transform transition-all duration-500 hover:scale-105">
          Genesis
        </button>
      </router-link>
    </nav>

    <!-- Currency and Buy now -->
    <div class="hidden lg:flex items-center">
      <div class="relative mr-4">
        <div class="w-10 h-10 mb-1 flex items-center justify-center border border-[#141523] rounded-full text-[#141523] text-md cursor-pointer" @click="toggleCurrencyDropdown"> 
          {{ supportedCurrencies[cardwarePrefs.selectedCurrency] }}
        </div>        
        <transition name="fade">
          <div v-if="showCurrencyDropdown" class="absolute top-15 right-0 bg-white border border-gray-300 p-2 rounded-md shadow-lg">
            <select v-model="cardwarePrefs.selectedCurrency" @change="updateDisplayedPrice" class="border text-sm border-gray-300 p-2 rounded-md focus:outline-none focus:border-[#FF6000]">
              <option v-for="(symbol, key) in supportedCurrencies" :key="key" :value="key">
                {{ key }}
              </option>
            </select>
          </div>
        </transition>
      </div>
      <router-link to="/shop" class="relative text-xs md:text-sm p-2 w-24 md:w-36 h-12 border-[#FF6000] bg-[#FF6000] shadow-2xl border-2 rounded-3xl text-white hover:text-[#141523] text-center hover:bg-transparent transition duration-300 mr-8 mb-2 flex items-center justify-center">
        <h2 class="absolute inset-0 flex items-center justify-center font-archivomedium">BUY NOW</h2>
      </router-link>
    </div>

    <!-- Mobile Menu Toggle Button -->
      <button @click.stop="toggleMenu" class="lg:hidden text-[#141523] focus:outline-none z-50 p-2" :aria-expanded="isMenuOpen" aria-controls="mobile-menu" aria-label="Toggle menu" ref="toggleButton">
      <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path v-if="!isMenuOpen" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16m-7 6h7"/>
        <path v-else stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
      </svg>
    </button>

    <!-- Mobile Dropdown Menu -->
    <transition name="fade">
      <div v-if="isMenuOpen" id="mobile-menu" ref="mobileMenu" class="lg:hidden absolute top-full right-0 left-0 bg-[#FFF9F7] p-5 space-y-4 z-50 border-t border-[#E48D7A] shadow-lg">
        <router-link to="/shop">
          <button class="w-full text-left text-[#141523] hover:text-[#FF6000] py-2" @click="closeMenu">Products</button>
        </router-link>
        <router-link to="/wallet">
          <button class="w-full text-left text-[#141523] hover:text-[#FF6000] py-2" @click="closeMenu">Wallet</button>
        </router-link>
        <router-link to="/learn">
          <button class="w-full text-left text-[#141523] hover:text-[#FF6000] py-2" @click="closeMenu">Resources</button>
        </router-link>
        <router-link to="/enterprise">
          <button class="w-full text-left text-[#141523] hover:text-[#FF6000] py-2" @click="closeMenu">Enterprise</button>
        </router-link>
        <router-link to="/blog">
          <button class="w-full text-left text-[#141523] hover:text-[#FF6000] py-2" @click="closeMenu">Blog</button>
        </router-link>
        <router-link to="/genesisgiveaway">
          <button class="w-full text-left text-[#141523] hover:text-[#FF6000] pt-2" @click="closeMenu">Genesis Giveaway</button>
        </router-link>

        <div class="relative flex items-center space-x-2">
          <div class="w-8 h-8 flex items-center justify-center border border-[#141523] rounded-full text-[#141523] cursor-pointer" @click="toggleCurrencyDropdown">
            {{ supportedCurrencies[cardwarePrefs.selectedCurrency] }}
          </div>
            <transition name="fade">
              <div v-if="showCurrencyDropdown" class="absolute top-10 left-0 bg-white border border-gray-300 p-2 rounded-md shadow-lg">
                <select v-model="cardwarePrefs.selectedCurrency" @change="updateDisplayedPrice" class="border text-sm border-gray-300 p-1.5 rounded-md focus:outline-none focus:border-[#FF6000]">
                  <option v-for="(symbol, key) in supportedCurrencies" :key="key" :value="key">
                    {{ key }}
                  </option>
                </select>
              </div>
            </transition>
          </div>

        <router-link to="/shop">
          <button class="w-full mt-4 bg-[#FF6000] text-white hover:text-[#141523] py-2 rounded-full border-2 border-[#FF6000] hover:bg-transparent transition duration-300" @click="closeMenu">
            BUY NOW
          </button>
        </router-link>
      </div>
    </transition>

    <!-- Overlay for Blurring Background -->
    <teleport to="body">
      <div
        v-if="isMenuOpen"
        class="fixed inset-0 bg-black bg-opacity-30 backdrop-blur-md z-40"
        @click="closeMenu">   
      </div>
    </teleport>

  </header>
</template>

<script setup>
import { ref, reactive, onMounted } from 'vue'

const isMenuOpen = ref(false);

function toggleMenu() {
  isMenuOpen.value = !isMenuOpen.value;
}

function closeMenu() {
  isMenuOpen.value = false;
}

const supportedCurrencies = {
  USD: '$',
  GBP: '£',
  EUR: '€',
  ZAR: 'R',
  JPY: '¥',
  CNY: '¥'
}

let cardwarePrefs = reactive({
  selectedCurrency: 'USD'
})

const showCurrencyDropdown = ref(false) 

onMounted(async () => {
  const prefsString = localStorage.getItem('cardwarePrefs')
  if (prefsString) {
    Object.assign(cardwarePrefs, JSON.parse(prefsString))
  }
})

function updateDisplayedPrice() {
  localStorage.setItem('cardwarePrefs', JSON.stringify(cardwarePrefs))
  window.location.reload();

}

function toggleCurrencyDropdown() {
  const prefsString = localStorage.getItem('cardwarePrefs')
  if (prefsString) {
    Object.assign(cardwarePrefs, JSON.parse(prefsString))
  }
  showCurrencyDropdown.value = !showCurrencyDropdown.value
}

</script>

<style scoped>

.drop-bounce {
  animation: drop-bounce 0.4s linear;
}

@keyframes drop-bounce {
  0% {
    transform: translateY(0px);
  }
  20% {
    transform: translateY(0px);
  }
  40% {
    transform: translateY(20px);
  }
  60% {
    transform: translateY(0px);
  }
  80% {
    transform: translateY(0px);
  }
  100% {
    transform: translateY(0px);
  }
}


.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s ease;
}
.fade-enter-from, .fade-leave-to {
  opacity: 0;
}
.fade-enter-to, .fade-leave-from {
  opacity: 1;
}

.genesis-btn {
  position: relative;
  overflow: hidden;
}

.genesis-btn::before {
  content: "";
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: linear-gradient(120deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0.3) 50%, rgba(255,255,255,0) 100%);
  transform: translateX(-100%) rotate(45deg);
  transition: transform 0.5s ease;
}

.genesis-btn:hover::before {
  transform: translateX(100%) rotate(45deg);
}

</style>
